<nz-header class="section-header">
  {{ "Speech Therapy" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.parkinsonsQuestionnaire) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="4"
      [historyItems]="getTemplateItems(4)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.becksDepressionInventory) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="6"
      [historyItems]="getTemplateItems(6)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.oralClinicalAssessmentOfDeposition) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="7"
      [historyItems]="getTemplateItems(7)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
